import { useQuery } from "@tanstack/react-query";

import { getClientsClientIDDocuments } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { CLIENTS_QUERY_KEYS } from "./queryKeys";

export function useClientDocumentsQuery(clientID: string | undefined) {
  return useQuery({
    queryKey: CLIENTS_QUERY_KEYS.documents(clientID!),
    queryFn: processResponse(() => getClientsClientIDDocuments(clientID!)),
    enabled: !!clientID,
  });
}
